import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { BaseBean, PageListBean } from "../ds/client_ds.js";
import {
  RestReadRequest,
  RestServiceListRequest,
  ServiceBean,
  ServiceSearchCriteria,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class ServiceDetailsListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
  }
  componentDidMount() {}
  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  editService = (e, val, rowData) => {
    if (e.detail === 1) this.props.editService(val);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  render() {
    let serviceList = this.props.serviceList;
    return (
      <div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "uomCode")}>
                  UOM{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "uomCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "price")}>
                  Price{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "price" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            {serviceList != null ? (
              <tbody>
                {serviceList.map((ln, index) => (
                  <tr key={index}>
                    <td>
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.editService(e, ln.code, ln)}
                      >
                        {ln.code}
                      </Button>
                    </td>
                    <td>{ln.description}</td>
                    <td>{ln.uomCode}</td>
                    <td>{ln.price}</td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {serviceList.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
class ServiceDetailsEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
  }
  componentDidMount() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  onUOMCodeChange = (e) => {
    this.props.onUOMCodeChange(e);
  };
  uomEnterKeyEvent = (e) => {
    this.props.uomEnterKeyEvent(e);
  };
  displayAutoCompleteUomList = (list) => {
    this.props.displayAutoCompleteUomList(list);
  };
  render() {
    let serviceDetailsData = this.props.serviceDetailsData;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Company</FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputTextbox
              type="text"
              name="companyCode"
              onChange={this.onChange}
              value={serviceDetailsData.companyCode}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Service Code</FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputTextbox
              ref={this.codeRef}
              name="code"
              type="text"
              placeholder="Enter Service Code"
              disabled={isDisableFields}
              onChange={this.onChange}
              value={serviceDetailsData.code}
              style={{ "text-transform": "uppercase" }}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Name</FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Service Name"
              onChange={this.onChange}
              value={serviceDetailsData.description}
              style={{ "text-transform": "uppercase" }}
              isMandatory={true}
            />{" "}
          </Col>
        </Row>
        <br />
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>UOM</FormLabel>{" "}
          </Col>
          <Col sm="3">
            {" "}
            <InputTextbox
              name="uomCode"
              type="text"
              placeholder="UOM Code"
              onChange={this.onUOMCodeChange}
              value={serviceDetailsData.uomCode}
              lookupRequired={true}
              lookupHandler={this.props.uomLookupHandler}
              enterKeyEventHandler={this.uomEnterKeyEvent}
              autoCompleteListData={this.props.uomPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteUomList}
              showAutoCompleteList={this.props.isShowAutoCompleteUomList}
              style={{ "text-transform": "uppercase" }}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Price</FormLabel>{" "}
          </Col>
          {
            <Col sm="3">
              {" "}
              <NumberFormatInputbox
                name={"price"}
                onChange={this.onChange}
                placeholder="Enter price"
                value={serviceDetailsData.price}
                className="text-right"
                decimalScale={2}
                isMandatory={true}
              />
            </Col>
          }
          <Col sm="1">
            <FormLabel>is Active</FormLabel>
          </Col>
          <Col sm="2">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={serviceDetailsData.isActive}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

class ServiceDetailsList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      serviceList: [],
      pageTitle: "Service Details",
      serviceDetailsData: new ServiceBean(),
      pageList: new PageListBean(),
      criteria: new ServiceSearchCriteria(),
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      currentPageNumber: 0,
      totalCount: 0,
      isListFormOpen: true,
      isEntryFormOpen: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowExitButton: true,
      loadingText: "",
      isLoading: false,
      progressLoadingText: "",
      isShowProgressBarPopup: false,
      isDisableFields: false,
      order: "asc",
      sortField: "",
      uomLookupHandler: null,
      uoms: [],
      isShowAutoCompleteUomList: false,
      uomPageListForAutoCompleteList: new Array(),
    };
    this.moduleCaption = "ServiceDetails";
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;

    let serviceDetailsData = new ServiceBean();
    serviceDetailsData.companyCode = this.companyCode;
    this.loadPage(1);
    this.setState({ serviceDetailsData: serviceDetailsData });
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };

    const uoms = new Array();
    if (!isEmptyArray(attribute_cache.uoms)) uoms.push(...attribute_cache.uoms);
    this.state.uoms = uoms;

    setTimeout(() => {
      this.initLookupHandlers();
    }, 2000);
  }
  initLookupHandlers = () => {
    let uomLookupHandler = new GenericAttributeLookupHandler(
      this.state.uoms,
      "UOM"
    );
    this.setState({ uomLookupHandler: uomLookupHandler });
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  onChange = (e) => {
    let serviceDetailsData = this.state.serviceDetailsData;
    serviceDetailsData[e.target.name] = e.target.value;
    this.setState({ serviceDetailsData: serviceDetailsData });
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadServicePage(criteria, pageInput);
  };
  validateData = (data) => {
    let isValidateData = false;
    let err_list = [];
    let errorMessage = "";
    if (data == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.code)) {
        let errMsg = "Code is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.description)) {
        let errMsg = "Name is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidateData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValidateData = true;
      this.setState({ isShowAlert: false });
    }
    return isValidateData;
  };
  save = () => {
    this.saveService();
  };
  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeEntryForm();
  };
  cleardata = () => {
    let serviceDetailsData = new ServiceBean();
    serviceDetailsData.companyCode = this.companyCode;
    this.setState({
      serviceDetailsData: serviceDetailsData,
    });
  };
  clickGoButton = () => {
    let serviceDetailsData = this.state.serviceDetailsData;
    this.editService(serviceDetailsData.code);
  };
  openEntryForm = () => {
    this.setState({
      isListFormOpen: false,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
      isEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowAlert: false,
    });
  };
  closeEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isListFormOpen: true,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isDisableFields: false,
    });
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.clickGoButton();
    }, 200);
  };
  loadPageResponse = (response) => {
    if (
      response.data != null &&
      response.data.service != null &&
      response.data.service.serivces != null
    ) {
      let serviceList = response.data.service.serivces;
      let pageList = this.state.pageList;
      pageList.currentPage = response.data.service.currentPage;
      pageList.pageSize = response.data.service.pageSize;
      pageList.totalCount = response.data.service.totalCount;
      this.setState({
        serviceList: serviceList,
        pageList: pageList,
      });
    }
  };
  loadServicePage = (criteria, pageList) => {
    let requestInput = new RestServiceListRequest();
    requestInput.searchCriteria = criteria;
    requestInput.pageInput = pageList;
    if (SecurityAccessManager.serviceDetailsView_isAccessible()) {
      MasterService.getServicePageList(
        requestInput,
        this.loadPageResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadSaveResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
    this.cleardata();
    this.closeEntryForm();
  };
  saveService = () => {
    let input = this.state.serviceDetailsData;
    if (input.isFetched == true) {
      if (SecurityAccessManager.serviceDetailsEdit_isAccessible()) {
        MasterService.updateService(
          input,
          this.loadSaveResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (SecurityAccessManager.serviceDetailsCreate_isAccessible()) {
        MasterService.createService(
          input,
          this.loadSaveResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadEditResponse = (response) => {
    if (response.data != null) {
      if (response.data.serviceBean != null) {
        let serviceData = response.data.serviceBean;
        this.setState({
          serviceDetailsData: serviceData,
        });
        this.disable();
      }
    }
    this.openEntryForm();
  };
  editService = (code) => {
    let readRequest = new RestReadRequest();
    readRequest.companyCode = this.companyCode;
    readRequest.code = code;
    if (SecurityAccessManager.serviceDetailsEdit_isAccessible()) {
      MasterService.readService(
        readRequest,
        this.loadEditResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.serviceList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ serviceList: sorted });
    }
  };
  onUOMCodeChange = (e) => {
    let uomCode = e.target.value;
    this.state.isShowAutoCompleteUomList = true;
    let tempData = this.state.serviceDetailsData;
    let showAutoCompleteList = this.state.isShowAutoCompleteUomList;
    if (isEmpty(uomCode)) {
      this.state.isShowAutoCompleteUomList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteUomList;
      let tempData = this.state.serviceDetailsData;
      tempData.uomCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteUomList: showAutoCompleteList,
        serviceDetailsData: tempData,
        uomPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "uomCode" &&
      showAutoCompleteList === true &&
      uomCode !== ""
    ) {
      this.readUomBySearchString(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ serviceDetail: tempData });
  };
  uomEnterKeyEvent = (e) => {
    this.readUom(e.target.value);
    this.state.isShowAutoCompleteUomList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteUomList;
    this.setState({
      uomPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteUomList: showAutoCompleteList,
    });
  };
  displayAutoCompleteUomList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteUomList: isShowAutoCompleteList,
    });
  };
  readUomBySearchString = (searchString) => {
    let uomData = this.state.uoms;
    let simpleAutoCompleteList = new Array();
    if (uomData.length > 0 && uomData != null) {
      uomData.map((obj) => {
        let uomBean = {
          description: obj.description,
          code: obj.code,
        };
        simpleAutoCompleteList.push(uomBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      uomPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readUom = (uomCode) => {
    let tempData = this.state.serviceDetailsData;
    let uomBean = null;
    let uomData = null;
    this.state.uoms.map((ln) => {
      if (ln.code === uomCode) {
        uomBean = ln;
        uomData = new BaseBean();
        uomData.code = ln.code;
        uomData.description = ln.description;
      }
    });
    if (!isEmpty(uomBean)) {
      tempData.uomCode = uomBean.code;
      this.state.isShowAutoCompleteUomList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteUomList;
      this.setState({
        serviceDetail: tempData,
        isShowAutoCompleteUomList: showAutoCompleteList,
      });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <ProgressBar
          closeAlertModalCallBack={this.closeAlertProgressBarModalCallBack}
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
            loadingText={this.state.loadingText}
            isLoading={this.state.isLoading}
          />
        )}
        {this.state.isListFormOpen && (
          <div>
            <Row>
              <Col sm="1">
                <FormLabel id="searchBarLabel">Service</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  enterKeyEventHandler={this.enterKeyEventHandler}
                  ref={this.listFormCodeRef}
                  type="text"
                  name="code"
                  onChange={this.onChange}
                  value={this.state.serviceDetailsData.code}
                  style={{ "text-transform": "uppercase" }}
                  isMandatory={true}
                ></InputTextbox>
              </Col>
              <Col sm="1">
                <Button
                  id="fabric_Add_Button"
                  className="text-center"
                  onClick={() => this.clickGoButton()}
                >
                  Go
                </Button>
              </Col>
            </Row>
          </div>
        )}
        {!this.state.isListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
          />
        )}
        {this.state.isListFormOpen && (
          <ServiceDetailsListForm
            {...this.state}
            clickGoButton={this.clickGoButton}
            editService={this.editService}
            enterKeyEventHandler={this.enterKeyEventHandler}
            onChange={this.onChange}
            handleSortingChange={this.handleSortingChange}
          />
        )}
        {this.state.isEntryFormOpen && (
          <ServiceDetailsEntryForm
            {...this.state}
            onChange={this.onChange}
            displayAutoCompleteUomList={this.displayAutoCompleteUomList}
            uomEnterKeyEvent={this.uomEnterKeyEvent}
            onUOMCodeChange={this.onUOMCodeChange}
          />
        )}
      </div>
    );
  }
}

function ServiceDetailsAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <ServiceDetailsList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default ServiceDetailsAttributeModule;
